import {Action} from '@ngrx/store';
import {ShiftDraft} from '@app/core/models/ShiftDraft.model';

export enum EShiftDraftsActions {
	GetShiftDrafts = '[ShiftDrafts] Get ShiftDrafts',
	GetShiftDraftsSuccess = '[ShiftDrafts] Get ShiftDrafts Success',
	SetSelectedShiftDraft = '[ShiftDrafts] Set selected ShiftDraft',
	CreateShiftDraft = '[ShiftDrafts] Create ShiftDraft',
	CreateShiftDraftSuccess = '[ShiftDrafts] Create ShiftDraft Success',
	DeleteShiftDraft = '[ShiftDrafts] Delete ShiftDraft',
	DeleteShiftDraftSuccess = '[ShiftDrafts] Delete ShiftDraft Success',
	ReleaseShiftDraft = '[ShiftDrafts] Release ShiftDraft',
	ReleaseShiftDraftSuccess = '[ShiftDrafts] Release ShiftDraft Success',
	SetIsReleasingDraft = '[ShiftDrafts] Set Is Releasing Draft',
}

export class GetShiftDrafts implements Action {
	public readonly type = EShiftDraftsActions.GetShiftDrafts;

	constructor(public page: number, public page_size: number) {
	}
}

export class GetShiftDraftsSuccess implements Action {
	public readonly type = EShiftDraftsActions.GetShiftDraftsSuccess;

	constructor(public shiftDrafts: ShiftDraft[]) {
	}
}

export class SetSelectedShiftDraft implements Action {
	public readonly type = EShiftDraftsActions.SetSelectedShiftDraft;

	constructor(public shiftDraft: ShiftDraft) {
	}
}

export class CreateShiftDraft implements Action {
	public readonly type = EShiftDraftsActions.CreateShiftDraft;

	constructor(public shiftDraft: ShiftDraft) {
	}
}

export class CreateShiftDraftSuccess implements Action {
	public readonly type = EShiftDraftsActions.CreateShiftDraftSuccess;

	constructor(public shiftDraft: ShiftDraft) {
	}
}

export class DeleteShiftDraft implements Action {
	public readonly type = EShiftDraftsActions.DeleteShiftDraft;

	constructor(public shiftDraft: ShiftDraft) {
	}
}

export class DeleteShiftDraftSuccess implements Action {
	public readonly type = EShiftDraftsActions.DeleteShiftDraftSuccess;

	constructor(public shiftDraft: ShiftDraft) {
	}
}

export class ReleaseShiftDraft implements Action {
	public readonly type = EShiftDraftsActions.ReleaseShiftDraft;

	constructor(public shiftDraft: ShiftDraft) {
	}
}

export class ReleaseShiftDraftSuccess implements Action {
	public readonly type = EShiftDraftsActions.ReleaseShiftDraftSuccess;

	constructor(public shiftDraft: ShiftDraft) {
	}
}

export class SetIsReleasingDraft implements Action {
	public readonly type = EShiftDraftsActions.SetIsReleasingDraft;

	constructor(public isReleasingDraft: boolean) {
	}
}

export type ShiftDraftsActions =
	GetShiftDrafts |
	GetShiftDraftsSuccess |
	SetSelectedShiftDraft |
	CreateShiftDraft |
	CreateShiftDraftSuccess |
	DeleteShiftDraft |
	DeleteShiftDraftSuccess |
	ReleaseShiftDraft |
	ReleaseShiftDraftSuccess |
	SetIsReleasingDraft
	;
